var getTitleCase = function getTitleCase(str) {
  return str && str.toLowerCase().replace(/(^|\s)([a-z])/g, function (searchValue) {
    return searchValue.toUpperCase();
  });
};
export var getLocationString = function getLocationString(city, state, zipcode) {
  var cityString = city ? "".concat(getTitleCase(city), ", ") : '';
  var stateString = state ? "".concat(state, " ") : '';
  return cityString + stateString + zipcode;
};